import "./editor.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import * as Yup from "yup";

import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Paper,
  Typography,
} from "@material-ui/core";
import { EditorState, convertToRaw } from "draft-js";
import { Field, Form, Formik } from "formik";
import { insertText, toolbarOptions } from "./editorFunctions";

import CustomAlert from "../../components/CustomAlert";
import CustomDialog from "../../components/CustomDialog";
import { Editor } from "react-draft-wysiwyg";
import { TextField as FormikTextField } from "formik-material-ui";
import { createMailTemplate } from "../../../services/mailTemplatesService";
import draftToHtml from "draftjs-to-html";
import { makeStyles } from "@material-ui/core";
import useLocale from "../../../hooks/useLocale";
import { useMutation } from "react-query";
import { useState } from "react";
import GovGrButton from "../../../components/GovGrButton";

const useStyles = makeStyles((theme) => ({
  DialogFill: {
    overflow: "hidden",
    paddingBottom: 0,
  },
  container: {
    height: "50rem",
    width: "100%",
  },
  description: {
    height: "1rem",
    marginBottom: "0.5rem",
  },
  itemContainer: {
    height: "20rem",
    margin: "2.5rem 0 0.5rem 0",
  },
  itemContainerPaper: {
    height: "100%",
  },
  wrapperEditor: {
    height: "90%",
    [theme.breakpoints.down("lg")]: {
      height: "65%",
    },
    padding: "0.1rem",
  },

  parameters: {
    height: "10rem",
    [theme.breakpoints.down("lg")]: {
      margin: "0.5rem 0 2rem 0",
    },
  },
  parametersPaper: {
    height: "90%",
    marginTop: "0.2rem",
  },
  parametersBox: {
    height: "100%",
    padding: "0.5rem",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      backgroundColor: "#fff",
      width: "16px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#fff",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#babac0",
      borderRadius: "16px",
      border: "4px solid #fff",
    },
    "&::-webkit-scrollbar-button": {
      display: "none",
    },
  },
  insertButton: {
    margin: "0.25rem",
    fontSize: "0.8rem",
  },
}));
const CreateDialog = ({ open, close, refetch, mailColumns }) => {
  const classes = useStyles();
  const [error, setError] = useState("");
  // const [editorState, setEditorState] = useState(MUIEditorState.createEmpty());
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  const { t } = useLocale();
  // Mutation for creating data
  const { mutate } = useMutation(createMailTemplate, {
    onSuccess: (data) => {
      refetch();
      // setEditorState(MUIEditorState.createEmpty());
      setEditorState(EditorState.createEmpty());

      close();
    },
    onError: (error) => {
      switch (error) {
        default: {
          setError(t("A network error occured. Please try again later"));
        }
      }
    },
  });

  const validationSchema = Yup.object().shape({
    dscr: Yup.string().required(t("Field is required")).max(256, t("Too long")),
    mail_txt: Yup.string()
      .required(t("Field is required"))
      .max(4000, t("Too long")),
  });

  const handleCreateItem = (values) => {
    mutate({ items: JSON.stringify([values]) });
  };

  // Function that on button click gets the value and calls insertText
  const handleInsertEditor = (e) => {
    setEditorState(insertText(e.currentTarget.value, editorState));
  };

  // Close Modal
  const handleClose = () => {
    close();
    setEditorState(EditorState.createEmpty());
  };

  return (
    <CustomDialog open={open} maxWidth="md" onClose={handleClose}>
      <DialogTitle id="form-dialog-title">
        {t("Add a new Mail Template")}
      </DialogTitle>
      <DialogContent className={classes.DialogFill}>
        <DialogContentText>
          {t(
            "Fill in the form below and click on Add to add a new Mail Template"
          )}
        </DialogContentText>
      </DialogContent>
      <CustomAlert
        open={!!error}
        close={() => {
          setError("");
        }}
        message={t("A network error occured, please try again later")}
      />
      <Formik
        initialValues={{
          dscr: "",
          mail_txt: null,
        }}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          handleCreateItem(values);
          setSubmitting(false);
        }}
      >
        {({ submitForm, isSubmitting, setFieldValue }) => (
          <Form>
            <DialogContent>
              <Grid direction="column" container>
                <Grid item className={classes.description}>
                  <Field
                    component={FormikTextField}
                    fullWidth
                    name="dscr"
                    label={t("Description")}
                  />
                </Grid>
                <Grid item className={classes.itemContainer}>
                  <Paper className={classes.itemContainerPaper}>
                    <Editor
                      editorState={editorState}
                      wrapperClassName={classes.wrapperEditor}
                      editorClassName="editorWrapper"
                      toolbar={toolbarOptions()}
                      onEditorStateChange={(newState) => {
                        setEditorState(newState);
                        setFieldValue(
                          "mail_txt",
                          draftToHtml(
                            convertToRaw(editorState?.getCurrentContent())
                          )
                        );
                      }}
                    />
                  </Paper>
                </Grid>
                <Grid item className={classes.parameters}>
                  <Typography variant="h6">Παραμετρικά</Typography>
                  <Paper className={classes.parametersPaper}>
                    <div className={classes.parametersBox}>
                      {mailColumns.map((columnName, index) => {
                        return (
                          <GovGrButton
                            style={{ display: "inline", margin: 5 }}
                            key={index}
                            value={columnName}
                            onClick={handleInsertEditor}
                            buttonText={columnName}
                          />
                        );
                      })}
                    </div>
                  </Paper>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={submitForm} color="primary">
                {t("Add")}
              </Button>
              <Button onClick={handleClose} color="primary">
                {t("Cancel")}
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </CustomDialog>
  );
};

export default CreateDialog;
